import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { SessionStateService } from '../session/session-state.service';

/**
 * Agrega a cada peticion el contexto con el que se abrio el WebView:
 * la sesion de billetera-core (X-User-Session, que el middleware propaga a
 * Laravel), el tenant (X-Tenant-Token, con el que el middleware elige el nucleo
 * de prestamos) y la entidad (X-Entity-Id, que hoy solo se transporta).
 */
export const sessionHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  if (environment.useMock) {
    return next(req);
  }

  const session = inject(SessionStateService);
  const headers: Record<string, string> = {};

  const sessionId = session.sessionId();
  if (sessionId && !req.headers.has('X-User-Session')) {
    headers['X-User-Session'] = sessionId;
  }

  const tenant = session.tenant();
  if (tenant && !req.headers.has('X-Tenant-Token')) {
    headers['X-Tenant-Token'] = tenant;
  }

  const entityId = session.entityId();
  if (entityId && !req.headers.has('X-Entity-Id')) {
    headers['X-Entity-Id'] = entityId;
  }

  if (Object.keys(headers).length === 0) {
    return next(req);
  }

  return next(req.clone({ setHeaders: headers }));
};
